// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"AllianzDeposit_modal-content_1_Edl"};